import { useEffect } from "react";
import api from "@/lib/api";

/**
 * Analytics pixel (bonus idea D) — RGPD-safe first-party page counter.
 * Sends a lightweight POST /api/track/pageview on mount with only { path }.
 * NO cookie, NO IP, NO user id — the server aggregates counts per (path, day).
 *
 * Safe to add on any public page. Silently ignores errors so it can never
 * break the UI.
 */
export default function AnalyticsPixel({ path }) {
    useEffect(() => {
        const p = path || (typeof window !== "undefined" ? window.location.pathname : "");
        if (!p) return;
        // Debounce identical fires within the same tab-session
        const key = `rf_pv_${p}`;
        if (typeof sessionStorage !== "undefined" && sessionStorage.getItem(key)) return;
        try {
            if (typeof sessionStorage !== "undefined") sessionStorage.setItem(key, "1");
        } catch (_) { /* private mode / storage disabled */ }
        api.post("/track/pageview", { path: p }).catch(() => { /* silent */ });
    }, [path]);
    return null;
}
